const ITEMS = [
  "Goodyear Welted",
  "Hand-Stitched",
  "Small MOQs",
  "Private Label",
  "Quick Sampling",
  "Mens · Ladies · Kids",
  "True Moccasins",
  "Leather Garments",
  "Accessories",
  "Made in India",
];

export const Marquee = () => {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[#0F1B3D] text-[#F9F8F6] overflow-hidden py-6 border-y border-[#B8945F]/30"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {doubled.map((item, idx) => (
          <span
            key={idx}
            data-testid={`marquee-item-${idx}`}
            className="inline-flex items-center mx-8 font-serif text-2xl md:text-3xl"
          >
            {item}
            <span className="mx-8 text-[#B8945F]">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
